import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import CountryDtl from './CountryDtl';

const CountryView = () => {
    return (
        <Fragment>
            <Breadcrumbs mainTitle='View Group' parent='Group' title='Group Detail' />
            <Container fluid={true}>
                <div className='edit-profile'>
                    <Row>
                        <CountryDtl />
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default CountryView